import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { useDetectDevice } from "../../hooks";
import { sliderItems, slidesPerDevice } from "../../data/home";
import { t } from "../../utils/utils";
import { useAppStore } from "../../store/useAppStore";

export function HomeSlider() {
  const device = useDetectDevice();
  const { appLang } = useAppStore();

  return (
    <div className="textBloks ourServices v2">
      <div className="head1">{t.ourServices}</div>
      <div className="cont1 textBloks slider">
        <Swiper
          slidesPerView={slidesPerDevice[device]}
          spaceBetween={0}
          loop={true}
          navigation={true}
          modules={[Pagination, Navigation]}
          className="mySwiper"
          style={{
            "--swiper-navigation-size": "32px",
          }}
        >
          {sliderItems[appLang]?.map((el) => {
            return (
              <SwiperSlide>
                <div className="item" key={el.title}>
                  <img className="textImg" src={el.img} alt={el.title} />
                  <div className="head2">{el.title}</div>
                  <div className="text1">{el.text}</div>
                  <Link className="link1" to={el.link}>
                    {t.details}
                  </Link>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}
